export default "__VITE_ASSET__C4X3BPD2__"